import React, { useEffect, useState } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import { relatorioAction, empresaAction } from '../../_actions'
import PropTypes from 'prop-types'
import SearchIcon from '@mui/icons-material/Search';
import TitleContentInformation from '../TitleContentInformation'
import moment from 'moment'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { STATUS_ORCAMENTO } from '../../utils'
import { faFileExcel, faFilePdf } from '@fortawesome/free-solid-svg-icons'
import {
  Autocomplete,
  Card,
  CardContent,
  CircularProgress,
  Grid,
  Paper,
  Skeleton,
  Table,
  TableContainer,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField
} from '@mui/material'
import { toast } from 'react-toastify'
import { withStyles } from '@mui/styles'
import { withRouter } from 'react-router-dom'
import { AccessControl } from '../../components/Utils/AccessControl'
import AccessDenied from '../Errors/AccessDenied'
import { Page } from 'components'
import { styled } from '@mui/material/styles';
import {
  TextValidator,
  ValidatorForm,
} from 'react-material-ui-form-validator'
import CustomButton from '../../components/CustomButton/CustomButton'

const styles = (theme) => ({
  root: {
    padding: theme.spacing(6, 6, 6, 6)
  },
  textField: {
    fontSize: 8
  }
})

const RelatorioOrcamentoOrdemServico = (props) => {

  const dispatch = useDispatch()
  const { classes, className, ...rest } = props
  const { relatorio } = props.relatorio
  const { totalRegistros } = props.relatorio
  const { isLoading } = props.relatorio

  const getTodayDate = (): string => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  };

  const [valueEmpresa, setValueEmpresa] = useState(null);
  const [inputValueEmpresa, setInputValueEmpresa] = useState('');
  const [openEmpresa, setOpenEmpresa] = useState(false)
  const [dataHoraInicio, setDataHoraInicio] = useState('');
  const [dataHoraFim, setDataHoraFim] = useState(getTodayDate());

  const [ready, setReady] = React.useState(false);

  const { idOrgao } = useSelector(
    (state) => state.usuarioOrgao
  )

  const { empresa } = useSelector(
    (state) => state.empresa)

  function getTotal() {
    if (relatorio && relatorio.length > 0) {

      let total = relatorio.length;

      return total;

    } else {
      return 0;
    }
  }

  useEffect(() => {
    dispatch(empresaAction.getEmpresaSelect({ IdOrgao: idOrgao }));

  }, [idOrgao]);

  useEffect(() => {
    dispatch(relatorioAction.clear());
  }, [])

  const optionsEmpresas = empresa.map(u => ({ id: u.value, nome: u.text }));

  const handlePrint = () => {
    if (dataHoraFim != '' && dataHoraFim != null && dataHoraInicio != null && dataHoraInicio != '') {
      window.open('/relatorioOrdensServicoOrcamentosPrint', '_blank');
    }
  }

  let payload = {
    IdEmpresa: valueEmpresa ? valueEmpresa.id : 0,
    DataIntervaloInicio: dataHoraInicio,
    DataIntervaloFim: dataHoraFim
  };

  const handleExportExcel = () => {
    dispatch(relatorioAction.getRelatorioOrcamentosEnviadosEmpresaArquivo(payload))
  }

  const handleSubmit = () => {
    if (dataHoraFim != '' && dataHoraFim != null && dataHoraInicio != null && dataHoraInicio != '') {
      if (dataHoraFim >= dataHoraInicio) {
        dispatch(relatorioAction.getRelatorioOrcamentosEnviadosEmpresa(payload, true));
      } else {
        toast.error('Data do intervalo de início não pode ser maior que a data de intervalo de fim')
      }
    } else {
      toast.error('Selecione um intervalo de datas!');
    }
  };

  useEffect(() => {
    if (valueEmpresa) {
      handleChangeAutocompleteEmpresa(valueEmpresa)
    }
  }, [valueEmpresa])

  const handleChangeAutocompleteEmpresa = (obj) => {
    if (obj != null) {
      let selectedEmpresa = empresa.filter(
        (item) => item.value == obj.id
      )

      dispatch(
        empresaAction.changeDetailsEmpresa(
          selectedEmpresa[0]
        )
      )
    } else {

    }
    setOpenEmpresa(false)
  }

  useEffect(() => {

  }, [totalRegistros, isLoading]);

  useEffect(() => {
  }, [ready, props.relatorio.isLoading])

  return (
    <Page className={classes.root} title="Relatório - Orçamentos enviados por empresas para as Ordens de Serviço">
      <AccessControl
        rule={'relatorios.list'} //permissão necessária para acessar conteúdo
        yes={() => (
          <Grid
            {...rest}
            container
            spacing={2}
          >
            <Grid item lg={12} md={12} xl={12} xs={12}>
              <Card style={{ marginBottom: 10, marginTop: 0 }}>
                <ValidatorForm
                  id="formRelatorioOrcamentosOrdemServico"
                  onSubmit={(event) => handleSubmit(event)}
                >
                  <CardContent>
                    <TitleContentInformation
                      subTitle={'RELATÓRIO'}
                      title={'Orçamentos enviados por empresas para as Ordens de Serviço'}
                    />
                    <Grid container spacing={2}>
                      <Grid item lg={6} md={6} xl={6} xs={12} style={{ marginTop: 17 }}>
                        <Autocomplete
                          value={valueEmpresa}
                          onChange={(event, newValue) => {
                            setValueEmpresa(newValue);
                          }}
                          inputValue={inputValueEmpresa}
                          onInputChange={(event, newInputValueEmpresa) => {
                            setInputValueEmpresa(newInputValueEmpresa);
                          }}
                          id="controllable-states-demo"
                          options={optionsEmpresas}
                          margin="normal"
                          variant="outlined"
                          defaultValue={valueEmpresa}
                          getOptionLabel={(o) => (o ? o.nome : '')}
                          renderInput={(params) => <TextField {...params} label="Empresa... " fullWidth />}
                          fullWidth
                        />
                      </Grid>
                      <Grid item lg={3} md={3} xl={3} xs={12}>
                        <TextValidator
                          className={classes.textField}
                          fullWidth
                          id="data"
                          InputLabelProps={{
                            shrink: true
                          }}
                          type="date"
                          label="Data Intervalo Início"
                          margin="normal"
                          onChange={(e) => setDataHoraInicio(e.target.value)}
                          value={dataHoraInicio || ''}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item lg={3} md={3} xl={3} xs={12}>
                        <TextValidator
                          className={classes.textField}
                          fullWidth
                          id="data"
                          InputLabelProps={{
                            shrink: true
                          }}
                          type="date"
                          label="Data Intervalo Fim"
                          margin="normal"
                          onChange={(e) => setDataHoraFim(e.target.value)}
                          value={dataHoraFim || ''}
                          variant="outlined"
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={2} style={{ alignItems: 'center', justifyContent: 'left', alignContent: 'left' }}>
                      <Grid item xl={12} lg={12} md={12} xs={12} style={{
                        alignItems: 'bottom',
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'right',
                        textAlign: 'right'
                      }}>
                        <Grid>
                          <CustomButton
                            type="submit"
                            variant="contained"
                            dark={true}
                            disabled={props.relatorio.isLoading}
                            startIcon={<SearchIcon />}
                            endIcon={props.relatorio.isLoading && <CircularProgress size={24} />}
                          >
                            {props.relatorio.isLoading ? 'Pesquisando...' : 'Pesquisar'}
                          </CustomButton>
                        </Grid>
                        <Grid>
                          <CustomButton
                            type="submit"
                            onClick={() => handlePrint()}
                            variant="outlined"
                            endIcon={<FontAwesomeIcon icon={faFilePdf} style={{ verticalAlign: 'middle' }} />}
                          >
                            Gerar PDF
                          </CustomButton>
                        </Grid>
                        <Grid>
                          <CustomButton
                            type="button"
                            onClick={() => handleExportExcel()}
                            variant="outlined"
                            endIcon={<FontAwesomeIcon icon={faFileExcel} style={{ verticalAlign: 'middle' }} />}
                          >
                            Exportar para Excel
                          </CustomButton>
                        </Grid>
                      </Grid>
                    </Grid>
                  </CardContent>
                </ValidatorForm>
              </Card>
              <Card>
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell><strong>DATA</strong></TableCell>
                        <TableCell><strong>EMPRESA</strong></TableCell>
                        <TableCell><strong>ORDEM DE SERVIÇO</strong></TableCell>
                        <TableCell><strong>VALOR</strong></TableCell>
                        <TableCell><strong>STATUS</strong></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {undefined !== relatorio && relatorio.length
                        ? relatorio.map((n) => {
                          return (
                            <TableRow hover key={n.id}>
                              <TableCell component="th" scope="row">
                                {n.data ? moment(n.data).format('DD/MM/yyyy') : '-'}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {n.empresa.toUpperCase()}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {n.tituloOrdemServico ? n.tituloOrdemServico.toUpperCase() : '-'}
                              </TableCell>
                              <TableCell component="th" scope="row" align="right">
                                R$ {n.valor ? n.valor?.toLocaleString('pt-br', { minimumFractionDigits: 2 }) : '-'}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {n.status == STATUS_ORCAMENTO.APROVADO ? 'APROVADO' : STATUS_ORCAMENTO.REPROVADO ? 'REPROVADO' : 'PENDENTE'}
                              </TableCell>
                            </TableRow>
                          )
                        })
                        :
                        (dataHoraFim != null && dataHoraInicio != null ?
                          (isLoading ?
                            Array.apply(null, { length: 6 }).map((e, i) => (
                              <TableRow hover>
                                <TableCell component="th" scope="row">
                                  <Skeleton animation="wave" />
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  <Skeleton animation="wave" />
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  <Skeleton animation="wave" />
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  <Skeleton animation="wave" />
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  <Skeleton animation="wave" />
                                </TableCell>
                              </TableRow>
                            ))
                            :
                            <TableRow>
                              <TableCell rowSpan={6} colSpan={5} align="center">Nenhum registro encontrado</TableCell>
                            </TableRow>
                          )
                          :
                          <TableRow>
                            <TableCell rowSpan={6} colSpan={3} align="center">Selecione um intervalo de datas para prosseguir</TableCell>
                          </TableRow>
                        )
                      }
                      {undefined !== relatorio && relatorio.length
                        ?
                        <TableRow>
                          <TableCell rowSpan={2} colSpan={4}><b>TOTAL DE ORÇAMENTOS</b></TableCell>
                          <TableCell rowSpan={2}><b>{getTotal()}</b></TableCell>
                        </TableRow>
                        :
                        null
                      }
                    </TableBody>
                  </Table>
                </TableContainer>
              </Card>
            </Grid>
          </Grid>
        )
        }
        no={() => <AccessDenied />}
      />
    </Page >
  )
}
RelatorioOrcamentoOrdemServico.propTypes = {
  classes: PropTypes.object.isRequired
}
const mapStateToProps = (state) => {
  return {
    relatorio: state.relatorio
  }
}
const connectedRelatorioOrcamentoOrdemServicoPage = withRouter(
  connect(mapStateToProps, null, null, {
    pure: false
  })(withStyles(styles)(RelatorioOrcamentoOrdemServico))
)
export { connectedRelatorioOrcamentoOrdemServicoPage as RelatorioOrcamentoOrdemServico }
